import { render, staticRenderFns } from "./PDPModalCompare.vue?vue&type=template&id=432b0c2e&scoped=true"
import script from "./PDPModalCompare.vue?vue&type=script&lang=js"
export * from "./PDPModalCompare.vue?vue&type=script&lang=js"
import style0 from "./PDPModalCompare.vue?vue&type=style&index=0&id=432b0c2e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432b0c2e",
  null
  
)

export default component.exports